import {useSyncExternalStore} from 'react';

const subscribe = (callback: () => void) => {
  window.addEventListener('online', callback);
  window.addEventListener('offline', callback);
  return () => {
    window.removeEventListener('online', callback);
    window.removeEventListener('offline', callback);
  };
};

const getSnapshot = () => {
  return window.navigator.onLine;
};

export const useIsOnline = () => {
  const isOnline = useSyncExternalStore(subscribe, getSnapshot);

  return isOnline;
};
